// vim: set ts=2 sts=2 sw=2 et:

import { connect } from "react-redux";

import { Language } from "../../types/dataTypes";
import { GlobalState } from "../../types/stateTypes";
import { PlatformRef } from "../types";
import SpectatorView from "./SpectatorView";

interface OwnProps {
  platformRef: PlatformRef | null;
  locationSearch: string;
}

interface StateProps {
  language: Language;
}

export type SpectatorContainerProps = OwnProps & StateProps;

// The spectator display is a pure WebSocket view — every piece of data it shows arrives over the live
// broadcast, and the device that opens it usually has NO meet loaded (default meet = platformsOnDays:[1]).
// So we do NOT gate on the local meet (that wrongly rejected platform 2 with "Invalid Spectator URL");
// a well-formed platformRef (parsePlatformRef returns non-null) is the only structural requirement.
const mapStateToProps = (state: GlobalState): StateProps => {
  return {
    language: state.language,
  };
};

export default connect(mapStateToProps)(SpectatorView);
